import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import LoadingPage from '../../components/LoadingPage'
import { getUser } from '../../../reducers'
import ListOutsourcing from './ListOutsourcing'
import NewOutsourcing from './NewOutsourcing'
import DetailsOutsourcing from './DetailsOutsourcing'
import { db, firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import cloneDeep from 'lodash/cloneDeep';
import './styles.css'

const outsourcingPages = {
    LIST_OUTSOURCING: 'LIST_OUTSOURCING',
    NEW_OUTSOURCING: 'NEW_OUTSOURCING',
    DETAILS_OUTSOURCING: 'DETAILS_OUTSOURCING'
}

const OutsourcingEmployee = props => {
    const [outsourcing, setOutsourcing] = useState(null)
    const [outsourcingPage, setoutsourcingPage] = useState(outsourcingPages.LIST_OUTSOURCING)
    const [clients, setClients] = useState(null)
    const [employees, setEmployees] = useState(null)
    const [outsourcingIdToEdit, setOutsourcingIdToEdit] = useState(null)

    const getData = () => {
        firestore.collection(`${Constants.MAIN_NODES.OUTSOURCING_ORDERS}`).get()
            .then(outsourcingDocs => {
                const outsourcingLoaded = {}
                if (!outsourcingDocs.empty) {
                    outsourcingDocs.forEach(doc => {
                        const outsourcing = doc.data()
                        outsourcingLoaded[outsourcing.id] = outsourcing
                    })
                }
                db.ref(Constants.MAIN_NODES.USERS).once('value')
                    .then(usersSnap => {
                        const clientsLoaded = {}
                        const employeesLoaded = {}
                        if (usersSnap.exists()) {
                            usersSnap.forEach(userSnap => {
                                const user = userSnap.val()
                                if (user.userType === Constants.USER_TYPES.CLIENT) {
                                    clientsLoaded[user.id] = user
                                }
                                if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                                    employeesLoaded[user.id] = user
                                }
                            })
                        }
                        setClients(clientsLoaded)
                        setOutsourcing(outsourcingLoaded)
                        setEmployees(employeesLoaded)
                    })
                    .catch(err => {
                        console.log('Error getting users: ' + JSON.stringify(err))
                    })
            })
            .catch(err => {
                console.log('Error getting outsourcing: ' + JSON.stringify(err))
                setOutsourcing([])
            })
        return <LoadingPage/>
    }

    const onNewOutsourcingBack = (isNewOutsourcing, newOutsourcing) => {
        if (isNewOutsourcing && newOutsourcing) {
            const outsourcedLoaded = cloneDeep(outsourcing)
            outsourcedLoaded[newOutsourcing.id] = newOutsourcing
            setOutsourcing(outsourcedLoaded)
            setoutsourcingPage(outsourcingPages.LIST_OUTSOURCING)
        } else {
            setoutsourcingPage(outsourcingPages.LIST_OUTSOURCING)
        }
    }

    const onShowOutsourcing = id => {
        if(id && outsourcing && outsourcing[id]) {
            setOutsourcingIdToEdit(id)
            setoutsourcingPage(outsourcingPages.DETAILS_OUTSOURCING)
        }
    }

    const onOutsourcingDeleted = id => {
        const outsourcingLoaded = cloneDeep(outsourcing)
        if (id && outsourcingLoaded && outsourcingLoaded[id]) {
            delete outsourcingLoaded[id]
            setOutsourcing(outsourcingLoaded)
        }
    }

    const onDetailsOutsourcingBack = (editOutsourcing, outsourcingToUpdate) => {
        if (editOutsourcing && outsourcingToUpdate) {
            const worksLoaded = cloneDeep(outsourcing)
            worksLoaded[outsourcingToUpdate.id] = outsourcingToUpdate
            setOutsourcing(worksLoaded)
            setoutsourcingPage(outsourcingPages.LIST_OUTSOURCING)
        } else {
            setoutsourcingPage(outsourcingPages.LIST_OUTSOURCING)
        }
    }

    const updateOutsourcing = (outsourcingToUpdate) => {
        if (outsourcingToUpdate) {
            const loaded = cloneDeep(outsourcing)
            loaded[outsourcingIdToEdit].name = outsourcingToUpdate.name
            loaded[outsourcingIdToEdit].phone = outsourcingToUpdate.phone
            loaded[outsourcingIdToEdit].email = outsourcingToUpdate.email
            loaded[outsourcingIdToEdit].category = outsourcingToUpdate.category
            setOutsourcing(loaded)
            setoutsourcingPage(outsourcingPages.LIST_OUTSOURCING)
        }
    }

    const updateOutsourcingData = (updated, workOrderId, outsourcingOrder) => {
        if (updated && workOrderId && outsourcingOrder) {
            const outsourcingLoaded = cloneDeep(outsourcing)
            outsourcingLoaded[outsourcingOrder.id].workOrderId = workOrderId 
            setOutsourcing(outsourcingLoaded)
        }
    }

    const renderWorkPage = page => {
        switch (page) {
            case outsourcingPages.LIST_OUTSOURCING:
                return <ListOutsourcing outsourcing={outsourcing} onOutsourcingDeleted={onOutsourcingDeleted}
                onShowOutsourcing={onShowOutsourcing} onNewSelected={() => setoutsourcingPage(outsourcingPages.NEW_OUTSOURCING)}
                onBack={updateOutsourcingData}
                />
            case outsourcingPages.DETAILS_OUTSOURCING:
                return <DetailsOutsourcing outsourcingToEdit={outsourcing[outsourcingIdToEdit]} employees={employees} clients={clients} onBack={onDetailsOutsourcingBack} onUpdateBidOrder={updateOutsourcing}/>
            case outsourcingPages.NEW_OUTSOURCING:
                return <NewOutsourcing outsourcing={outsourcing} onBack={onNewOutsourcingBack}/>
            default:
                return <ListOutsourcing onNewSelected={() => setoutsourcingPage(outsourcingPages.NEW_OUTSOURCING)}/>
        }
    }

    return (
        <div className="outsourcingEmployeeCont">
            {
                props.user ?
                outsourcing !== null ?
                        renderWorkPage(outsourcingPage)
                        :
                        getData()
                    :
                    <LoadingPage/>
            }
        </div>
    )
}

OutsourcingEmployee.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(OutsourcingEmployee))
